import { Flex, Text } from "@chakra-ui/react";
import React from "react";

interface Props {
  title: string;
  children: React.ReactNode;
  showBelow?: boolean;
  errorMessage: string | null;
}

export const ReviewRow = ({ title, children, showBelow, errorMessage }: Props) => {
  return (
    <Flex flexDirection={showBelow && !errorMessage ? "column" : "row"} p="2.5">
      <Flex flex={1} pr="5">
        <Text fontSize={"md"} fontWeight="bold">
          {title}
        </Text>
      </Flex>
      <Flex flex={3}>
        {errorMessage ? (
          <Text fontSize={"md"} color={"red.500"}>
            {errorMessage}
          </Text>
        ) : (
          children
        )}
      </Flex>
    </Flex>
  );
};
